import { EmailNotification } from './emailNotificationTypes';

export const EMAILNOTIFICATION_SLICE = 'emailNotification';

export const EMAILNOTIFICATION_INITIAL_STATE: EmailNotification = {
  isSidebarOpen: false,
};
